<template>
	<v-list-item
		:title="property.property_title"
		:to="$routerHelper.getPathByRouteName('property-detail', { title: property.property_title, id: property.id })"
		@click="close"
	>
		<v-list-item-avatar tile>
			<img
				:src="property.mainImage"
				:alt="property.property_title"
			>
		</v-list-item-avatar>

		<v-list-item-content>
			<v-list-item-title>{{ property.property_title }}</v-list-item-title>
			<v-list-item-subtitle>
				{{ property.category }}
				<span class="mid-sep">·</span>				
				{{ property.type_action }}
			</v-list-item-subtitle>
		</v-list-item-content>

		<v-list-item-action>
			<v-btn
				icon
				@click.stop.prevent="remove"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-list-item-action>
	</v-list-item>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	props: {
		property: {
			type: Object,
			default: () => ({})
		},
		close: {
			type: Function,
			default: () => {}
		}
	},

	methods: {
		...mapActions({
			removeFavorite: 'property/removeFavorite'
		}),

		remove () {
			this.removeFavorite(this.property.id)
			this.close()
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
